// Helpers. (Any state afected on this functions)
import _ from 'lodash';
import moment from 'moment-timezone';
import { FilterQueryParams, getParamsOrDeleteNumber, getParamsOrDeleteString } from '.';

export const prepareFilter = (queryParams, filters, dates, dateQueryProp) => {
    const { dateFrom, dateTo } = dates;

    const newQueryParams = { ...queryParams };
    const newFilters = new FilterQueryParams();

    // Handle filter date range
    if (dateFrom && dateTo) {
        const startAt = moment(dateFrom).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
        const endAt = moment(dateTo).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');

        newFilters.between((dateQueryProp ?? 'created_at'), startAt, endAt);
    }

    _.forEach(filters, filter => {
        if (filter.property.description) {
            let valueToFilter = filter.property.type === 'select' ? filter.value?.id : filter.value;

            const operator = filter.property.operator;
            if (operator === 'like') valueToFilter = `*${valueToFilter}*`;
            if (operator === 'in') valueToFilter = filter.value;
            if (typeof filter.property.description === 'object') newFilters[operator](filter.property.description[valueToFilter], valueToFilter);
            newFilters[operator](filter.property.description, valueToFilter);
        }
    });

    // Delete or update sortOrder, sortField, pageNumber, pageSize
    const params = new URLSearchParams(window.location.search);
    params.get('sortOrder') && (newQueryParams.sortOrder = getParamsOrDeleteString(params, 'sortOrder'));
    params.get('sortField') && (newQueryParams.sortField = getParamsOrDeleteString(params, 'sortField'));
    params.get('pageNumber') && (newQueryParams.pageNumber = getParamsOrDeleteNumber(params, 'pageNumber'));
    params.get('pageSize') && (newQueryParams.pageSize = getParamsOrDeleteNumber(params, 'pageSize'));
    params.get('dateFrom') || params.delete('dateFrom');
    params.get('dateTo') || params.delete('dateTo');

    newQueryParams.filters = newFilters;
    return newQueryParams;
};
export const prepareAuditFilter = (queryParams, dates) => {
    const { dateFrom, dateTo } = dates;
    const newQueryParams = { ...queryParams };
    const newFilters = new FilterQueryParams();

    // Handle filter date range
    if (dateFrom && dateTo) {
        const startAt = moment(dateFrom).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
        const endAt = moment(dateTo).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');

        newFilters.between('created_at', startAt, endAt);
    }

    newQueryParams.filters = newFilters;
    return newQueryParams;
};

export const exportCsvFileNameDates = (startAt, endAt) => {
    let formattedStartAt = startAt;
    let formattedEndAt = endAt;

    if (startAt && endAt) {
        const localEndAt = moment.utc(endAt).tz('America/Argentina/Buenos_Aires');
        const localNow = moment().tz('America/Argentina/Buenos_Aires');
        const isToday = localEndAt.isSame(localNow, 'day');

        formattedStartAt = moment.utc(startAt).tz('America/Argentina/Buenos_Aires').format('YYYY-MM-DD HH_mm_ss');
        formattedEndAt = localEndAt.format('YYYY-MM-DD HH_mm_ss');
        if (isToday) {
            formattedEndAt = localNow.format('YYYY-MM-DD HH_mm_ss');
        }
    }

    return { formattedStartAt, formattedEndAt };
};

export const prepareRemuneratedFilter = (search, date, filtersList) => {
    const newFilters = new FilterQueryParams();

    if (date[0] && date[1]) {
        const startAt = moment(date[0]).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
        const endAt = moment(date[1]).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
        newFilters.between('created_at', startAt, endAt);
    }

    const stateValue = filtersList[0]?.value;
    if (stateValue && Number.isInteger(stateValue.id)) {
        newFilters.equal('active', stateValue.id);
    }

    const trimmed = search.trim();
    if (trimmed.length >= 3) {
        const isNumeric = /^\d+$/.test(trimmed);
        if (isNumeric) {
            newFilters.like('id', trimmed);
        }
        else {
            newFilters.like('full_name', trimmed);
        }
    }

    return newFilters;
};

/**
 * Sanitizes a search input string by removing special characters.
 * Allows letters (including accented), numbers, dots and commas.
 * @param {string} value - Raw input string
 * @returns {string} Sanitized string
 */
export const sanitizeSearchInput = (value) => value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚüÜñÑ0-9.,]/g, '');

/**
 *
 * @param {*} typesToFilter is the original list
 * @param {*} filtersList is the list that we can't select again
 * @returns A list with filters availables
 */
export const excludingFilters = (typesToFilter, filtersList) => {
    const losIds = filtersList.map(filter => filter.property.id);
    return typesToFilter.filter((filter) => {
        return losIds.indexOf(filter.id) === -1;
    });
};
